var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCkCongratulation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.263,
    height: 102.087,
    viewBox: "0 0 102.263 102.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Congratulation",
    transform: "translate(-668.896 -345.566)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_834",
    "data-name": "Ellipse 834",
    cx: 51.043,
    cy: 51.043,
    r: 51.043,
    transform: "translate(668.896 345.566)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M154.392,145.15c-2.758,2.2-5.895,4.747-5.895,4.747l-11.367-10s-10.509-1.458-15.631-1.828c-13.169-.948-23.917,13.036-28.45,18.519-2.935,11.992-2,21.176,3.752,34.324,0,0,28.781,28.933,29.673,28.933,23.566-1.334,46.34-22.492,46.34-50.716,0-.848.085-3.751.045-4.589Z",
    transform: "translate(598.289 227.538)",
    fill: "#ad1409"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flat_Color",
    "data-name": "Flat Color",
    transform: "translate(685.256 361.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5799",
    "data-name": "Path 5799",
    d: "M34.714,68.178a33.464,33.464,0,1,1,0-66.928,32.779,32.779,0,0,1,15,3.58A2.339,2.339,0,0,1,47.6,9,28.016,28.016,0,0,0,34.714,5.888,28.795,28.795,0,1,0,63.509,34.714a6.224,6.224,0,0,0,0-.778,2.345,2.345,0,0,1,4.669-.436v1.214A33.5,33.5,0,0,1,34.714,68.178Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5800",
    "data-name": "Path 5800",
    d: "M23.588,39.7a2.179,2.179,0,0,1-1.619-.685L6.933,24.261a2.335,2.335,0,0,1,0-3.3,2.4,2.4,0,0,1,3.331,0L23.619,34.129,53.659,4.587a2.4,2.4,0,0,1,3.331,0,2.335,2.335,0,0,1,0,3.3L25.3,39.016a2.3,2.3,0,0,1-1.712.685Z",
    transform: "translate(10.566 5.629)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCkCongratulation);
export default __webpack_public_path__ + "static/media/ck_congratulation.836ce1d94708eb764c8bb7c1980eddca.svg";
export { ForwardRef as ReactComponent };